import * as React from 'react';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {KPI_ERROR_NOT_UNIQUE} from '../kpiUtils';

type Props = {
	errorMessage: string;
	kpiName: string;
};
type ErrorProps = {
	kpiName: string;
};

const MultipleError = ({kpiName}: ErrorProps) => (
	<div className="kpi-widget-content error-message">
		<Trans
			i18nKey="dashboard.widgets.error.multiplekpis"
			values={{
				kpiName
			}}>
			There are multiple kpis with the same name(s) `{kpiName}` assigned to this asset - please ensure that the
			names are unique by renaming the kpis
		</Trans>
	</div>
);

const DefaultError = ({kpiName}: ErrorProps) => (
	<div className="kpi-widget-content error-message">
		<Trans
			i18nKey="dashboard.widgets.error.configerror"
			values={{
				kpiName
			}}>
			The KPI(s) with name `{kpiName}` can not be loaded - please assure your configuration
		</Trans>
	</div>
);

export const KpiError = ({errorMessage, kpiName}: Props) =>
	errorMessage.indexOf(KPI_ERROR_NOT_UNIQUE) !== -1 ? (
		<MultipleError kpiName={kpiName} />
	) : (
		<DefaultError kpiName={kpiName} />
	);
export const OutdatedConfigError = () => (
	<div className="kpi-widget-content error-message">
		<Trans i18nKey="dashboard.widgets.error.kpiOutdatedConfigError">
			The configuration structure of the KPI widget changed - please reconfigure the widget
		</Trans>
	</div>
);
